import { Popup } from "@/components/Popup";
import { importIcon } from "@/designSystemIcons";
import { showModal } from "@/redux/message/messageSlice";
import { AppDispatch } from "@/redux/store";
import { IOS_CLUB_IMPORT_APP_URL } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { useDispatch } from "react-redux";

export const IosImportPopup = () => {
  const { t } = useTranslation("clubImport");
  const dispatch = useDispatch<AppDispatch>();
  return (
    <Popup
      title={t("mobile.title")}
      onClose={() => dispatch(showModal())}
      actionTitle={t("iosPopup.action")}
      titleIcon={importIcon}
      handleActionClicked={() => {
        window.open(IOS_CLUB_IMPORT_APP_URL, "_blank");
      }}
    >
      <div
        className="w-84 small-mobile:w-100 px-6 pt-8 flex flex-col items-center mx-auto gap-y-10 "
        style={{
          background:
            "radial-gradient(46.03% 45.98% at 37% 31.14%, #085271 0%, rgba(8, 82, 113, 0.00) 100%)",
        }}
      >
        <img
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fc25/my-club/mobile-club-import/hero-image.png"
          }
          alt={t("mobile.title")}
          className="h-20"
        />
        <p>{t("iosPopup.body")}</p>
      </div>
    </Popup>
  );
};
